<template>
  <div>
    <md-dialog :md-active="open" class="modal-agg-category">
      <span
        class="material-icons close text-right"
        @click="closeModal"
      >close</span
      >
      <div class="body-modal-agg-category">
        <md-dialog-title>AGREGAR A CATEGORIA</md-dialog-title>

        <div id="multiselect-categories" class="form-group mt-3">
          <Multiselect
            v-model="category"
            tag-placeholder="Agregar nueva categoria"
            label="title"
            track-by="id"
            placeholder="Selecciona categoria"
            :options="getMediaCategories"
            deselect-label="Remover categoria"
            :searchable="true"
            :allow-empty="true"
          >
            <template #noResult>
              <div>Sin resultados</div>
            </template>
          </Multiselect>
        </div>

        <md-dialog-actions>
          <md-button
            class="md-button md-primary md-theme-default"
            @click="closeModal"
          >CANCELAR
          </md-button
          >
          <base-button
            :loading="isLoading"
            class="md-primary w-100 "
            @click="send()"
          >
            GUARDAR
          </base-button
          >
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import {
  MEDIA_ASSIGN_CATEGORY_TO_FILE,
} from '@/store/actions/media';

export default {
  components: {
    Multiselect,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  emits: ['close-modal', 'success'],
  data () {
    return {
      category: null,
      isLoading: false,
    };
  },
  computed: {
    open: {
      get: function() {
        return this.isOpen;
      },
      set: function() {
        this.closeModal();
      },
    },
    ...mapGetters(['getMediaCategories']),
  },
  watch: {
    item: function(newVal) {
      if (newVal && newVal?.category) {
        this.category = newVal.category;
      }
    },
  },
  methods: {
    notify (type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
    closeModal () {
      this.$emit('close-modal', 'assignCategory');
      this.category = null;
    },
    async send () {

      this.isLoading = true;

      const data = {
        media_id: this.item.id,
        category_id: this.category ? this.category.id : null,
      };

      try {
        await this.$store
          .dispatch(MEDIA_ASSIGN_CATEGORY_TO_FILE, data);
        this.notify('success', 'Se ha asignado la categoria éxito');
        this.$emit('success');
      } catch {
        this.notify('danger', 'Tenemos problemas para asignar la categoria', 'danger');
        return this.isLoading = false;
      }

      this.isLoading = false;

      return this.closeModal();
    },
  },
};
</script>

<style scoped>


#multiselect-categories >>> .multiselect__tag {
  background-color: #b7227e !important;
  line-height: 25px !important;
}

#multiselect-categories >>> .multiselect__tag-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

#multiselect-categories >>> .multiselect__tag .multiselect__tag-icon:after {
  color: white;
  font-size: 20px !important;
  line-height: 0 !important;
  font-weight: 400 !important;
}

#multiselect-categories >>> .multiselect__tag .multiselect__tag-icon:hover {
  color: white;
  background-color: #b7227e;
}

#multiselect-categories >>> .multiselect__input,
.multiselect__tag {

  line-height: 20px !important;
}

#multiselect-categories >>> .multiselect__input {
  padding: 0px !important;
  font-size: 16px;
  letter-spacing: 0.01em;
}


#multiselect-categories >>> .multiselect__single {
  display: flex;
  justify-content: center;
  align-items: center;
}

#multiselect-categories >>> .multiselect__select {
  height: 50px;
  width: 50px;
}

#multiselect-categories >>> .multiselect__option--selected {
  background: #b5016d !important;
  color: #fff !important;
  font-weight: 500 !important;
}

#multiselect-categories >>> .multiselect--above .multiselect__content-wrapper {
  top: 100% !important;
  bottom: auto !important;
}

#multiselect-categories >>> .multiselect__option--highlight {
  background: black;
  outline: none;
  color: #fff;
}

#multiselect-categories >>> .multiselect__option--highlight::after {
  background: black;
  outline: none;
  color: #000;
}
</style>
